import { IntlShape } from 'react-intl';
import { messages } from './messages';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.InfinityMarquee),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['terms'],
    },
  ],
  properties: {
    terms: {
      title: intl.formatMessage(messages.Terms),
      widgetOptions: {
        frontendOptions: {
          widget: 'textlines_widget',
        },
      },
    },
  },
  required: [],
});

export default Schema;
